import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpInterceptor,
  HttpEvent
} from '@angular/common/http';
import { Observable } from 'rxjs';

/**
 * Intercepts HTTP calls and makes sure it authenticates using Windows Authentication
 */
@Injectable()
export class WinAuthInterceptor implements HttpInterceptor {
  /**
   * Intercepts HTTP calls and makes sure it authenticates using Windows Authentication
   * @param req The request
   * @param next HttpHandler
   */
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    req = req.clone({
      withCredentials: true
    });
    return next.handle(req);
  }
}
